import React from "react";
import { useNavigate } from "react-router-dom";

const LandingPage = () => {
  const navigate = useNavigate();

  // Define the project options in the same structure as the main page
  const options = {
    newProject: {
      name: "New Project",
      description: "Set up a new Five9 project with guided configuration steps",
      route: "/new-project",
      icon: "🆕"
    },
    returningProject: {
      name: "Returning Project", 
      description: "Continue with an existing project using saved credentials",
      route: "/returning-project",
      icon: "🔄"
    }
  };

  const handleOptionSelect = (optionKey) => {
    console.log("Selected option:", optionKey);
    navigate(options[optionKey].route);
  };

  return (
    <div className="technology-selector">
      <div className="container">
        <header className="selector-header">
          <h1>Five9 DDW Import</h1>
          <p>Choose your project setup option</p>
        </header>

        <div className="technology-grid">
          {Object.keys(options).map((key) => {
            const option = options[key];
            return (
              <div
                key={key}
                className="technology-card"
                onClick={() => handleOptionSelect(key)}
              >
                <div className="tech-icon">{option.icon}</div>
                <h3>{option.name}</h3>
                <p>{option.description}</p>
                <button className="select-btn">
                  Select Option
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
